"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateMfpProCustomerAccountForm = void 0;
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const constants_1 = require("../../../../constants");
const createMfpProCustomerAccountProvider_1 = require("../../../../contexts/createMfpProCustomerAccountProvider");
const ProgressBar_1 = require("./ProgressBar");
const PersonalInformationStep_1 = require("./steps/PersonalInformationStep");
const AddressInformationStep_1 = require("./steps/AddressInformationStep");
const ProInformationStep_1 = require("./steps/ProInformationStep");
const LoginInformationStep_1 = require("./steps/LoginInformationStep");
const CreateMfpProCustomerAccountForm = () => {
    const [currentStep, setCurrentStep] = (0, react_1.useState)(0);
    const { t } = (0, react_i18next_1.useTranslation)(constants_1.constants.TRANSLATIONS_NAMESPACE);
    (0, react_1.useEffect)(() => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    }, [currentStep]);
    const updateCurrentStep = (increment) => setCurrentStep((prev) => prev + increment);
    const steps = (0, react_1.useMemo)(() => [
        react_1.default.createElement(PersonalInformationStep_1.PersonalInformationStep, { updateCurrentStep: updateCurrentStep }),
        react_1.default.createElement(AddressInformationStep_1.AddressInformationStep, { updateCurrentStep: updateCurrentStep }),
        react_1.default.createElement(ProInformationStep_1.ProInformationStep, { updateCurrentStep: updateCurrentStep }),
        react_1.default.createElement(LoginInformationStep_1.LoginInformationStep, { updateCurrentStep: updateCurrentStep }),
    ], [PersonalInformationStep_1.PersonalInformationStep, AddressInformationStep_1.AddressInformationStep, ProInformationStep_1.ProInformationStep, LoginInformationStep_1.LoginInformationStep]);
    return (react_1.default.createElement("div", { className: "boutik-customer-account-create-mfp-pro-account-container" },
        react_1.default.createElement("p", { className: "boutik-customer-account-create-mfp-pro-account-form-title" }, t("createMfpProCustomerAccount.formTitle")),
        react_1.default.createElement(ProgressBar_1.ProgressBar, { stepsCount: steps.length, currentStep: currentStep }),
        react_1.default.createElement(createMfpProCustomerAccountProvider_1.CreateMfpProCustomerAccountProvider, null,
            react_1.default.createElement("div", { className: "boutik-customer-account-create-mfp-pro-account-form-steps-container" }, steps[currentStep]))));
};
exports.CreateMfpProCustomerAccountForm = CreateMfpProCustomerAccountForm;
//# sourceMappingURL=CreateMfpProCustomerAccountForm.js.map